import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter, useLocation } from 'react-router-dom';
import { Button, Layout, Modal, Radio, Skeleton, Typography, Grid, Dropdown } from 'antd';
import { SearchOutlined, SettingOutlined, HistoryOutlined, FolderOpenFilled, MenuOutlined } from '@ant-design/icons';
import './Dashboard.css';
import CaseTableV2 from '../../../Case/components/CaseTableV2/CaseTable';
import SearchHistoryV2 from '../../../Case/components/SearchHistoryV2/SearchHistory';

import CaseDashboardV2 from "../../../Case/components/GenaScreen/CaseDashboard";
import RequestTest from "../../../Case/components/GenaScreen/SubmitRequest/SubmitRequest";
import { signOut } from '../../../Authentication/AuthenticationActions';
import { ALLOWED_ACTIONS, SYSTEM_ROLES } from '../../../../utils/Constants';
import Auth from "../../../../utils/Auth";
import { setPageTitle } from "../../DashboardActions";
import { getAllResourcesRequest } from "../../../Authorisation/AuthorisationApiActions";
import { getLoggedInUserPermissionTemplateRequest, getUserDetailsRequest, updateUserProfileRequest } from "../../../User/UserApiActions";
import { updateUserResources } from "../../../Authorisation/AuthorisationActions";
import UnAuthorized from "../../../../utils/components/UnAuthorized/UnAuthorized";
import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";

import appLogo from '../../../../assets/icons/genascreen-logo.png'
import SettingsComponent from '../../../Settings/components/Settings';
import PageNotFound from '../../../Authentication/components/PageNotFound/PageNotFound';
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon';
import CompleteProfileForm from '../../../User/components/UserProfile/CompleteProfileForm';
import ConstantMessages from '../../../../utils/Strings';

const { Content, Header } = Layout;
const { useBreakpoint } = Grid;

const DashboardComponent = (props) => {
  const screens = useBreakpoint();
  const location = useLocation()
  const [showLoader, setShowLoader] = useState(true)
  const [pathAllowed, setPathAllowed] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState(undefined)
  const [noActivityDetected, setNoActivityDetected] = useState(false)
  const messageModalRef = useRef()
  const [isFirstTimeLogin, setIsFirstTimeLogin] = useState(false);
  const isSuperAdmin = props.loggedInUser?.roles?.[0]?.name === SYSTEM_ROLES.SUPER_ADMIN
  const isAdmin = props.loggedInUser?.roles?.[0]?.name === SYSTEM_ROLES.ORG_MANAGER
  const [loadingUserData, setLoadingUserData] = useState(true);

  useEffect(() => {
    if (!loadingUserData) {
      if (props.loggedInUser?.roles[0].name !== "SUPER_ADMIN" && props.loggedInUser && (!props.loggedInUser.phone || !props.loggedInUser.location || (!props.loggedInUser.organization))) {
        setIsFirstTimeLogin(true);
      } else {
        setIsFirstTimeLogin(false)
      }
    }
  }, [props.loggedInUser, loadingUserData])

  const handleSubmitProfileUpdate = (formData) => {
    if (formData.phone.charAt(0) !== '+') {
      formData.phone = `+${formData.phone}`
    }
    props.updateUserProfile(props.loggedInUser.id, formData).then((res) => {
      if (res.hasOwnProperty('phone'))
        messageModalRef.current.setState({
          showModal: true,
          title: "",
          message: ConstantMessages.updateUserSuccessMessage,
          showOkButton: true,
          handleOk: () => { },
          okText: 'Ok',
          cancelText: 'Cancel',
        });
      setIsFirstTimeLogin(false);
    }).catch((err) => {
    });
  }
  /*
   * Check if the user is idle from last minutes, if so log out the user from the system
   */
  const detectNoActivity = () => {
    let IDLE_TIMEOUT = 30; //minutes
    let _idleSecondsCounter = 0;

    document.onclick = function () {
      _idleSecondsCounter = 0;
    };

    document.onmousemove = function () {
      _idleSecondsCounter = 0;
    };

    document.onkeypress = function () {
      _idleSecondsCounter = 0;
    };

    let interval = window.setInterval(CheckIdleTime, 60000);

    function CheckIdleTime() {
      _idleSecondsCounter++;
      if (_idleSecondsCounter >= IDLE_TIMEOUT) {
        setNoActivityDetected(true)
        clearInterval(interval);
      }
    }
  };

  useEffect(() => {
      props.getUserDetailsRequest(props.loggedInUser?.id).then((res) => {
        setLoadingUserData(false)
      }, (error) => {
        setLoadingUserData(false)
      });
  }, [])

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu.key ?? menu.target.value)
    switch (menu.key ?? menu.target.value) {
      case 'search':
        props.history.push('/search')
        break
      case 'cases':
        props.history.push('/cases')
        break
      case 'search-history':
        props.history.push('/search-history')
        break
      case 'settings':
        props.history.push('/settings')
        break
      case 'logout':
        props.signOut()
        break
      default:
    }
  };

  const validatePermissions = () => {
    const trimmedPath = location.pathname.replace(/^\/+/, '');
    let pathAllowed = ALLOWED_ACTIONS.indexOf(trimmedPath) >= 0;

    if (location.pathname.startsWith('/search-history')) pathAllowed = true
    else if (location.pathname.startsWith('/search')) pathAllowed = true
    else if (location.pathname.startsWith('/cases')) pathAllowed = true
    else if (location.pathname.startsWith('/settings')) pathAllowed = true
    else if (location.pathname.startsWith('/request-test')) pathAllowed = true

    setPathAllowed(pathAllowed)
  };

  const getMenuKeyFromPath = () => {
    if (location.pathname.startsWith('/search-history')) return 'search-history';
    if (location.pathname.startsWith('/search')) return 'search';
    if (location.pathname.startsWith('/cases')) return 'cases';
    if (location.pathname.startsWith('/settings')) return 'settings';
    return
  }

  useEffect(() => {
    setShowLoader(true)
    detectNoActivity();
    getUserResourcePermission().then(() => {
      validatePermissions();
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      setShowLoader(false)
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSelectedMenu(getMenuKeyFromPath(location.pathname));
    validatePermissions()
  }, [location.pathname]);

  useEffect(() => {
    if (!props.resources || !props.template) return

    const userResources = props.resources.map(resource => {
      const object = {
        name: resource.name,
        id: resource.id,
        CREATE: null,
        READ: null,
        UPDATE: null,
        DELETE: null
      };

      props.template.ResourceActions.forEach(action => {
        if (action.ResourceId === resource.id) {
          switch (action.type) {
            case "CREATE":
              object.CREATE = action.possession;
              break;

            case "READ":
              object.READ = action.possession;
              break;

            case "UPDATE":
              object.UPDATE = action.possession;
              break;

            case "DELETE":
              object.DELETE = action.possession;
              break;

            default:
          }
        }
      });

      return object;
    });

    props.updateUserResources(userResources);
  }, [props.resources, props.template])

  const getUserResourcePermission = async () => {
    if (!props.loggedInUser) return

    try {
      await props.getAllResources()

      await props.getUserPermissionTemplate(props.loggedInUser.id)
    } catch (err) {
    }
  }

  const clearSession = () => {
    Auth.logoutAndNavigateToLogin();
  }

  const renderMenu = () => {
    if (screens.lg) {
      return (
        <Radio.Group value={selectedMenu} onChange={handleMenuClick}>
          <Radio.Button value="search">
            <span className='flex-horizontal-gap-2'><CustomIcon name="Search" />Search</span>
          </Radio.Button>
          <Radio.Button value="cases">
            <span className='flex-horizontal-gap-2'><CustomIcon name="OpenFolder" />Cases</span>
          </Radio.Button>
          <Radio.Button value="search-history">
            <span className='flex-horizontal-gap-2'><CustomIcon name="History" />History</span>
          </Radio.Button>
          <Radio.Button value="settings">
            <span className='flex-horizontal-gap-2'><CustomIcon name="Settings" />Settings</span>
          </Radio.Button>
          <Radio.Button value="logout">
            <span className='flex-horizontal-gap-2'><CustomIcon name="Logout" />Logout</span>
          </Radio.Button>
        </Radio.Group>
      )
    }
    // if (screens.md) {
    //   return (
    //     <Radio.Group value={selectedMenu} onChange={handleMenuClick}>
    //       <Radio.Button value="search">
    //         <CustomIcon name="Search" />
    //       </Radio.Button>
    //       <Radio.Button value="cases">
    //         <CustomIcon name="OpenFolder" />
    //       </Radio.Button>
    //       <Radio.Button value="search-history">
    //         <CustomIcon name="History" />
    //       </Radio.Button>
    //       <Radio.Button value="settings">
    //         <CustomIcon name="Settings" />
    //       </Radio.Button>
    //     </Radio.Group>
    //   )
    // }
    return (
      <Dropdown
        menu={{
          items: [
            { key: 'search', label: <div className="flex-horizontal-gap-2"><CustomIcon name="Search" />Search</div> },
            { key: 'cases', label: <div className="flex-horizontal-gap-2"><CustomIcon name="OpenFolder" />Cases</div> },
            { key: 'search-history', label: <div className="flex-horizontal-gap-2"><CustomIcon name="History" />History</div> },
            { key: 'settings', label: <div className="flex-horizontal-gap-2"><CustomIcon name="Settings" />Settings</div> },
            { key: 'logout', label: <div className="flex-horizontal-gap-2"><CustomIcon name="Logout" />Logout</div> },
          ],
          onClick: handleMenuClick
        }}
        placement="bottomRight"
        trigger={['click']}
      >
        <Button icon={<CustomIcon name="Menu" />} />
      </Dropdown>
    )
  }

  const renderContent = () => {
    let content = null

    switch (location.pathname) {
      case '/search':
        content = <CaseDashboardV2 {...props} />
        break
      case '/cases':
        content = <CaseTableV2 {...props} />
        break
      case '/search-history':
        content = <SearchHistoryV2 {...props} />
        break
      case '/settings':
        content = <SettingsComponent {...props} />
        break
      case '/request-test':
        content = <RequestTest {...props} />
        break
      default:
        content = <PageNotFound />
    }

    return content
  }

  if (!props.loggedInUser) return <Redirect to="/" />

  return (
    <>
      <Layout className="gs-app-layout">
        <Header className="gs-app-header">
          {/* Logo on the Left */}
          <div className="flex-horizontal-gap-2">
            <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
            {isAdmin && <Typography.Title level={3} style={{ color: '#D65C5C', margin: '8px 0 0 0', fontSize: '16px' }}>Admin</Typography.Title>}
            {isSuperAdmin && <Typography.Title level={3} style={{ color: '#D65C5C', margin: '8px 0 0 0', fontSize: '16px' }}>Super Admin</Typography.Title>}
          </div>
          <div className="flex-horizontal-gap-1">
            {renderMenu()}
          </div>
        </Header>
        <Content className="gs-app-content">
          {
            (showLoader
              ?
              (<Skeleton active />)
              :
              (pathAllowed
                ?
                renderContent()
                :
                (<UnAuthorized />)
              )
            )
          }
        </Content>
      </Layout>
      <Modal
        open={props.showSessionExpiredModal}
        title="Session Expired"
        onOk={clearSession}
        closable={false}
        footer={[
          <Button key="submit" type="primary" onClick={clearSession}>
            Ok
          </Button>
        ]}>
        <p>{props.sessionExpiredError}</p>
      </Modal>
      <Modal
        open={noActivityDetected}
        title="No Activity Detected"
        onOk={clearSession}
        closable={false}
        footer={[
          <Button key="submit" type="primary" onClick={clearSession}>
            Ok
          </Button>
        ]}>
        <p>System has detected no activity in past 30 minutes. Please login again to continue.</p>
      </Modal>
      <Modal
        open={isFirstTimeLogin}
        title="Please take a minute to complete your profile"
        className='complete-prf'
        closable={false}
        width={700}
        footer={[]}
      >
        <div>
          <CompleteProfileForm handleSubmit={handleSubmitProfileUpdate} />
        </div>
      </Modal>
      <MessageModal ref={messageModalRef} />
      <GenaLoader showLoader={showLoader} />
    </>
  )
}

const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser,
    pageTitle: state.dashboard.pageTitle,
    secondaryTitle: state.dashboard.secondaryTitle,
    showSessionExpiredModal: state.auth.showSessionExpiredModal,
    sessionExpiredError: state.auth.sessionExpiredError,
    resources: state.authorisation.resources,
    template: state.authorisation.template,
    userResources: state.authorisation.userResources
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signOut: () => {
      dispatch(signOut())
    },

    getAllResources: () => {
      return dispatch(getAllResourcesRequest()).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    getUserPermissionTemplate: (userId = 0) => {
      return dispatch(getLoggedInUserPermissionTemplateRequest(userId)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    updateUserProfile: (id, data) => {
      return dispatch(updateUserProfileRequest(id, data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    getUserDetailsRequest: (id) => {
      return dispatch(getUserDetailsRequest(id)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },

    updatePageTitle: (pageTitle, enablePageTitle) => {
      dispatch(setPageTitle(pageTitle, enablePageTitle));
    },

    updateUserResources: (userResources) => {
      dispatch(updateUserResources(userResources));
    }
  }
};

let Dashboard = withRouter(DashboardComponent)

Dashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);

export default Dashboard;
